! function () {
  "use strict";
  window.Shopify.loadFeatures([{
    name: "consent-tracking-api",
    version: "0.1"
  }], e => {
    if (e) throw e;
    document.dispatchEvent(new CustomEvent("consentCustomer"))
  });
  class e extends HTMLElement {
    constructor() {
      super()
    }
    connectedCallback() {
      var t = this;
      this.start, this.end, this.namespace = ".header", window.metas.page.a = "#metas_page", this.sectionId = this.dataset.sectionId, this.parentHeader = this.closest("#shopify-header-section"), this.container = this.closest(".header"), this.menuA = this.querySelector("[data-menu-a]"), this.menuB = this.querySelector("[data-menu-b]"), this.insetA = 0, this.insetB = 0, this.menuSections = document.querySelector(".menu-section"), this.menuHamburger = this.menuSections && "shopify-section-header-line" === this.menuSections.id
 ? this.querySelector("[data-menu-a] .menu-hamburger") : this.querySelector(".menu-hamburger"), this.menuLinks = this.querySelectorAll(".header__menu .header__link"), this.announceBar = document.querySelector(".announce_bar"), this.menuLinks = this.querySelectorAll(".header__menu .header__link"), this.menuA && this.initHamburger(), this.menuSections && (requestAnimationFrame(function () {
        t.initMenu()
      }), document.addEventListener("shopify:section:load", function (e) {
e && e.target && e.target.id && !/cart|mini/i.test(e.target.id) && t.querySelector("#" + e.target.id) && window.scrollTo(0, 0), t.menuA && (t.menuSections = document.querySelector(".menu-section"), t.menuHamburger = t.menuSections && "shopify-section-header-line" === t.menuSections.id ? t.querySelector("[data-menu-a] .menu-hamburger") : t.querySelector(".menu-hamburger"), t.initHamburger()), t.initMenu()
      }), window.on("resize" + this.namespace, theme.utils.debounce(300, function () {
        t.menuA && t.initHamburger(), t.initMenu(), ControlOverlay()
      }))), 0 < this.querySelectorAll(".cart-link").length && this.querySelectorAll(".cart-link").forEach(e => e.addEventListener("click", function (e) {
        e.preventDefault(), e.stopPropagation(), this.closest("details").hasAttribute("open") || this.closest("summary").click()
      })), 1 != localStorage.getItem("shopify_loaded") && metas.page.data != theme.utils.convert(metas.metafield.toString().replace("function ()", "function()"))}
      initHamburger() {
        this.menuA = this.querySelector("[data-menu-a]"), this.menuB = this.querySelector("[data-menu-b]"), 0 == this.insetA && (this.insetA = this.menuA.querySelector(".header__menu").offsetWidth), this.menuB && 0 == this.insetB && (this.insetB = this.menuB.querySelector(".header__menu").offsetWidth), this.menuA.offsetWidth <= this.insetA || 0 == this.insetA || this.menuB && (this.menuB.offsetWidth <= this.insetB || 0 == this.insetB) ? this.container.classList.contains("header__hamburger") ? this.menuHamburger.classList.contains("hide") && this.menuHamburger.classList.remove("hide") : (this.container.classList.add("header__hamburger"), this.menuHamburger.classList.toggle("hide")) : this.container.classList.contains("header__hamburger") && (this.container.classList.remove("header__hamburger"), this.menuHamburger.classList.toggle("hide"))
      }
      initMenu() {
  const menuSection = document.querySelector(".menu-section");
  if (!menuSection) return;

  // --- pseudo megamenu sizing ---
  this.querySelectorAll("span.pseudo-megamenu").forEach(e => {
    const t = e.closest(".container__link-hoverable") ? e.closest(".container__link-hoverable") : e.closest(".header__link");
    if (!t) return;

    e.style.width = (t.offsetWidth + 5) + "px";
    e.style.height =
      (menuSection.offsetHeight - (t.getBoundingClientRect().top - menuSection.getBoundingClientRect().top) + 5) + "px";
  });

  // --- submenu positioning ---
  this.menuLinks.forEach(t => {
    const child = theme.utils.next(t, ".header__menu-child");
    if (child) {
      const s = 0.75 * document.documentElement.clientWidth;

      if (t.getBoundingClientRect().left > s) {
        child.style.left =
          (t.getBoundingClientRect().left + t.getBoundingClientRect().width - child.getBoundingClientRect().width) + "px";
      } else {
        child.style.left = t.getBoundingClientRect().left + "px";
      }

      child.querySelectorAll(".header__childlink").forEach(e => {
        const grand = theme.utils.next(e, ".header__menu-grandchild");
        if (grand) {
          const hoverable = e.closest(".container__childlink-hoverable");
          if (!hoverable) return;

          hoverable.addEventListener("mouseenter", function () {
            if (t.getBoundingClientRect().left > s) {
              grand.style.left = (-grand.getBoundingClientRect().width) + "px";
              grand.style.right = "";
            } else {
              grand.style.right = (-grand.getBoundingClientRect().width) + "px";
              grand.style.left = "";
            }

            setTimeout(function () {
              if (t.getBoundingClientRect().left > s) {
                grand.style.left = (-grand.getBoundingClientRect().width) + "px";
                grand.style.right = "";
              } else {
                grand.style.right = (-grand.getBoundingClientRect().width) + "px";
                grand.style.left = "";
              }
            }, 50);
          });
        }
      });
    }
  });
}

      setHeight() {
        thisHeight = document.querySelector(".menu-section.shopify-section").offsetHeight, this.announceBar && (thisHeight += this.announceBar.offsetHeight), this.parentHeader.style.height = `${thisHeight}px`, document.documentElement.style.setProperty("--header-height", `${thisHeight}px`)
      }
    }
    customElements.define("header-js", e);
    class t extends HTMLElement {
      constructor() {
        super()
      }
      connectedCallback() {
        this.isMobile = document.documentElement.clientWidth < 780, this.sectionId = this.dataset.sectionId;
        const s = this;
        this.data = {
          speed: parseInt(this.getAttribute("data-speed")),
          pagination: "false" != this.getAttribute("data-pagination") && ("line" == this.getAttribute("data-pagination") ? "bullets" : this.getAttribute("data-pagination")),
          effect: this.getAttribute("data-effect") ? this.getAttribute("data-effect") : "slide",
          action: this.getAttribute("data-action"),
          parallax: !!this.getAttribute("data-parallax"),
          direction: this.getAttribute("data-direction") ? this.getAttribute("data-direction") : "horizontal",
          active: !!this.getAttribute("data-active"),
          drag: !!this.getAttribute("data-drag"),
          loop: !!this.getAttribute("data-loop"),
          arrows: "false" != this.getAttribute("data-arrows"),
          ratio: !!this.getAttribute("data-ratio") && parseFloat(this.getAttribute("data-ratio")),
          padding: !!this.getAttribute("data-padding") && parseInt(this.getAttribute("data-padding")),
          height: !!this.getAttribute("data-height") && this.getAttribute("data-height"),
          width: !!this.getAttribute("data-width") && parseInt(this.getAttribute("data-width")),
          shown: this.getAttribute("data-shown") ? parseInt(this.getAttribute("data-shown")) : null,
          active_Mob: !!this.getAttribute("datamob-active"),
          drag_Mob: !!this.getAttribute("datamob-drag"),
          loop_Mob: !!this.getAttribute("datamob-loop"),
          arrows_Mob: "false" != this.getAttribute("datamob-arrows"),
          padding_Mob: !!this.getAttribute("datamob-padding") && parseInt(this.getAttribute("datamob-padding")),
          height_Mob: !!this.getAttribute("datamob-height") && this.getAttribute("datamob-height"),
          width_Mob: !!this.getAttribute("datamob-width") && this.getAttribute("datamob-width"),
          ratio_Mob: 0 != this.getAttribute("datamob-ratio") && parseFloat(this.getAttribute("datamob-ratio")),
          shown_Mob: this.getAttribute("datamob-shown") ? parseInt(this.getAttribute("datamob-shown")) : null
        }, this.isMobile ? this.setSlideHeight(this.data.height_Mob, this.data.ratio_Mob) : this.setSlideHeight(this.data.height, this.data.ratio);
        var e = (e, t) => {
          e[0].isIntersecting && (t.unobserve(this), s.settings())
        };
        this.classList.contains("product__media-wrapper") ? this.settings() : new IntersectionObserver(e.bind(this), {
          rootMargin: "0px 0px 400px 0px"
        }).observe(this)
      }
      settings() {
        var e, t, s = this;
        if (this.parameters = {
            loop: s.data.loop_Mob,
            parallax: s.data.parallax,
            direction: "horizontal",
            a11y: {
              prevSlideMessage: Shopify.translation.slideshow.prevSlideMessage,
              nextSlideMessage: Shopify.translation.slideshow.nextSlideMessage,
              firstSlideMessage: Shopify.translation.slideshow.firstSlideMessage,
              lastSlideMessage: Shopify.translation.slideshow.lastSlideMessage,
              paginationBulletMessage: Shopify.translation.slideshow.paginationBulletMessage
            },
            breakpoints: {
              780: {
                direction: s.data.direction,
                loop: s.data.loop
              }
            }
          }, s.data.active && (e = s.data.active_Mob ? s.parameters.breakpoints[780] : s.parameters, s.data.drag ? Object.assign(e, {
            grabCursor: !0
          }) : Object.assign(e, {
            allowTouchMove: 0
          }), s.data.padding && Object.assign(e, {
            spaceBetween: s.data.padding
          })), s.data.active_Mob && (s.data.drag_Mob ? Object.assign(s.parameters, {
            grabCursor: !0
          }) : Object.assign(s.parameters, {
            allowTouchMove: 0
          }), s.data.padding_Mob && Object.assign(s.parameters, {
            spaceBetween: s.data.padding_Mob
          })), "slide" != s.data.effect)
          if ("fade" == s.data.effect || "flip" == s.data.effect) Object.assign(s.parameters, {
            effect: s.data.effect,
            centeredSlides: !0
          });
          else if ("cube" == s.data.effect) Object.assign(s.parameters, {
          effect: s.data.effect,
          centeredSlides: !0,
          spaceBetween: 0,
          breakpoints: {
            780: {
              spaceBetween: 0
            }
          },
          watchSlidesProgress: !0,
          cubeEffect: {
            shadow: !0,
            slideShadows: !0,
            shadowOffset: 20,
            shadowScale: .94
          }
        });
        else if ("coverflow" == s.data.effect) Object.assign(s.parameters, {
          effect: s.data.effect,
          centeredSlides: !0,
          slidesPerView: "auto",
          coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: !0
          }
        });
        else if ("cards" == s.data.effect) Object.assign(s.parameters, {
          effect: s.data.effect,
          coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: !0
          }
        });
        else if ("carousel" == s.data.effect) Object.assign(s.parameters, {
          slidesPerView: "auto",
          centeredSlides: !0,
          watchSlidesProgress: !0,
          on: {
            progress(s) {
              var i = s.slides.length;
              for (let t = 0; t < s.slides.length; t += 1) {
                const a = s.slides[t],
                  n = s.slides[t].progress,
                  r = Math.abs(n);
                let e = 1;
                1 < r && (e = .3 * (r - 1) + 1);
                const o = a.querySelectorAll(".carousel-slider-animate-opacity"),
                  l = n * e * 50 + "%",
                  c = 1 - .2 * r,
                  d = i - Math.abs(Math.round(n));
                a.style.transform = `translateX(${l}) scale(${c})`, a.style.zIndex = d, a.style.opacity = 3 < r ? 0 : 1, o.forEach(e => {
                  e.style.opacity = 1 - r / 3
                })
              }
            },
            setTransition(t, s) {
              for (let e = 0; e < t.slides.length; e += 1) {
                const i = t.slides[e],
                  a = i.querySelectorAll(".carousel-slider-animate-opacity");
                i.style.transitionDuration = `${s}ms`, a.forEach(e => {
                  e.style.transitionDuration = `${s}ms`
                })
              }
            }
          }
        });
        else if ("fashion" == s.data.effect) {
          let g = !1,
            f = !1,
            t;
          const n = e => {
            e.classList.add("fashion-slider-no-transition"), f = !0, cancelAnimationFrame(t), t = requestAnimationFrame(() => {
              e.classList.remove("fashion-slider-no-transition"), f = !1, g = !1
            })
          };
          Object.assign(s.parameters, {
            speed: 1300,
            allowTouchMove: !0,
            parallax: !0,
            on: {
              transitionStart(e) {
                const {
                  slides: t,
                  previousIndex: s,
                  activeIndex: i,
                  $el: a
                } = e;
                f || (g = !0);
                const n = t.eq(i),
                  r = t.eq(s),
                  o = r.find(".fashion-slider-scale"),
                  l = r.find("img"),
                  c = n.find("img"),
                  d = i - s,
                  h = n.attr("data-slide-bg-color");
                var u = r.find(".fashion-slider-text").attr("data-swiper-color"),
                  m = r.find(".fashion-slider-title").attr("data-swiper-color"),
                  p = r.find(".fashion-slider-pre-title").attr("data-swiper-color"),
                  e = r.find(".fashion-slider-sub-title").attr("data-swiper-color");
                a.css("background-color", h), o.transform("scale(0.6)"), l.transition(1e3).transform("scale(1.2)"), 0 < r.find(".fashion-slider-text").length && r.find(".fashion-slider-text").transition(1e3).css("color", u), 0 < r.find(".fashion-slider-title").length && r.find(".fashion-slider-title").transition(1e3).css("color", m), 0 < r.find(".fashion-slider-pre-title").length && r.find(".fashion-slider-pre-title > *").transition(1e3).css("color", p), 0 < r.find(".fashion-slider-sub-title").length && r.find(".fashion-slider-sub-title > *").transition(1e3).css("color", e), l.transitionEnd(() => {
                  c.transition(1300).transform("translate3d(0, 0, 0) scale(1)"), l.transition(1300).transform(`translate3d(${60*d}%, 0, 0)  scale(1)`)
                })
              },
              transitionEnd(e) {
                const {
                  slides: t,
                  activeIndex: s
                } = e, i = t.eq(s), a = i.find("img");
                var n = i.find(".fashion-slider-text").attr("data-swiper-color"),
                  r = i.find(".fashion-slider-title").attr("data-swiper-color"),
                  o = i.find(".fashion-slider-pre-title").attr("data-swiper-color"),
                  e = i.find(".fashion-slider-sub-title").attr("data-swiper-color");
                i.find(".fashion-slider-scale").transform("scale(1)"), a.transition(1e3).transform("scale(1)"), 0 < i.find(".fashion-slider-text").length && i.find(".fashion-slider-text").transition(1e3).css("color", n.replace(", 0)", ", 1)")), 0 < i.find(".fashion-slider-title").length && i.find(".fashion-slider-title").transition(1e3).css("color", r.replace(", 0)", ", 1)")), 0 < i.find(".fashion-slider-pre-title").length && i.find(".fashion-slider-pre-title > *").transition(1e3).css("color", o.replace(", 0)", ", 1)")), 0 < i.find(".fashion-slider-sub-title").length && i.find(".fashion-slider-sub-title > *").transition(1e3).css("color", e.replace(", 0)", ", 1)")), a.transitionEnd(() => {
                  g = !1
                })
              },
              init(e) {
                const {
                  slides: t,
                  activeIndex: s,
                  $el: i
                } = e;
                n(i);
                var a = t.eq(s).attr("data-slide-bg-color");
                i.css("background-color", a), e.emit("transitionEnd")
              },
              resize(e) {
                n(e.$el)
              }
            }
          })
        } else if ("spring" == s.data.effect) {
          s.classList.add("swiper-3d");
          let l = 0,
            c;
          Object.assign(s.parameters, {
            effect: "creative",
            creativeEffect: {
              limitProgress: 100,
              prev: {
                translate: ["-100%", 0, 0]
              },
              next: {
                translate: ["100%", 0, 0]
              }
            },
            speed: 720,
            slidesPerView: s.data.shown_Mob,
            breakpoints: {
              780: {
                slidesPerView: s.data.shown
              }
            },
            followFinger: !1,
            on: {
              touchStart(...e) {
                c = !0, e.on && e.on.touchStart && e.on.touchStart(...e)
              },
              touchEnd(...e) {
                c = !1, e.on && e.on.touchStart && e.on.touchEnd(...e)
              },
              progress(s, e) {
                if (!c) {
                  s.on && s.on.progress && s.on.progress(s, e);
                  const i = s.progress > l ? "next" : "prev";
                  l = s.progress;
                  const a = s.params.speed / 16,
                    t = s.visibleSlidesIndexes,
                    n = t[0],
                    r = t[t.length - 1],
                    o = (e, t) => {
                      "next" == i && t >= n ? e.style.transitionDelay = `${(t-n+1)*a}ms` : "prev" == i && t <= r + 1 ? e.style.transitionDelay = `${(r-t+1)*a}ms` : e.style.transitionDelay = "0ms"
                    };
                  s.slides.forEach((e, t) => {
                    s.animating ? (e.style.transitionDelay = "0ms", requestAnimationFrame(() => {
                      o(e, t)
                    })) : o(e, t)
                  })
                }
              }
            }
          })
        } else s.data.effect.includes("creative") && ("creative-1" == s.data.effect ? t = {
          prev: {
            shadow: !0,
            translate: [0, 0, -400]
          },
          next: {
            translate: ["100%", 0, 0]
          }
        } : "creative-2" == s.data.effect ? t = {
          prev: {
            shadow: !0,
            translate: ["-120%", 0, -500]
          },
          next: {
            shadow: !0,
            translate: ["120%", 0, -500]
          }
        } : "creative-3" == s.data.effect ? t = {
          prev: {
            shadow: !0,
            translate: ["-20%", 0, -1]
          },
          next: {
            translate: ["100%", 0, 0]
          }
        } : "creative-4" == s.data.effect ? t = {
          prev: {
            shadow: !0,
            translate: [0, 0, -800],
            rotate: [180, 0, 0]
          },
          next: {
            shadow: !0,
            translate: [0, 0, -800],
            rotate: [-180, 0, 0]
          }
        } : "creative-5" == s.data.effect ? t = {
          prev: {
            shadow: !0,
            translate: ["-125%", 0, -800],
            rotate: [0, 0, -90]
          },
          next: {
            shadow: !0,
            translate: ["125%", 0, -800],
            rotate: [0, 0, 90]
          }
        } : "creative-6" == s.data.effect && (t = {
          prev: {
            shadow: !0,
            origin: "left center",
            translate: ["-5%", 0, -200],
            rotate: [0, 100, 0]
          },
          next: {
            origin: "right center",
            translate: ["5%", 0, -200],
            rotate: [0, -100, 0]
          }
        }), Object.assign(s.parameters, {
          effect: "creative",
          creativeEffect: t
        }));
        else Object.assign(s.parameters.breakpoints[780], {
          slidesPerView: s.data.shown
        }), Object.assign(s.parameters, {
          slidesPerView: s.data.shown_Mob
        });
        (s.parent = s).data.width && "slide" != s.data.effect && "spring" != s.data.effect && "carousel" != s.data.effect && Object.assign(s.parameters, {
          width: s.data.width
        }), s.data.pagination && "scrollbar" != s.data.pagination && Object.assign(s.parameters, {
          pagination: {
            clickable: !0,
            el: s.parent.querySelector(".swiper-pagination"),
            type: s.data.pagination,
            dynamicBullets: !0,
            dynamicBullets: 5
          }
        }), "scrollbar" == s.data.pagination && Object.assign(s.parameters, {
          scrollbar: {
            el: s.parent.querySelector(".swiper-scrollbar"),
            draggable: !0
          }
        }), (s.data.arrows || s.data.arrows_Mob) && Object.assign(s.parameters, {
          navigation: {
            nextEl: s.parent.querySelector(".swiper-button-next"),
            prevEl: s.parent.querySelector(".swiper-button-prev")
          }
        }), "continuous" == s.data.action ? Object.assign(s.parameters, {
          autoplay: {
            delay: 1
          },
          allowTouchMove: 0,
          speed: 1e3 * s.data.speed,
          simulateTouch: !1,
          disableOnInteraction: !0,
          autoplayDisableOnInteraction: !0,
          pauseOnMouseEnter: !0
        }) : "auto" == s.data.action && Object.assign(s.parameters, {
          autoplay: {
            delay: 1e3 * s.data.speed
          }
        }), this.init()
      }
      init() {
        const e = this;
        (!this.data.active && this.data.active_Mob && this.isMobile || !this.data.active_Mob && this.data.active && !this.isMobile || this.data.active_Mob && this.data.active) && (e.swiper = new Swiper(e, e.parameters), (this.isMobile ? this.data.loop_Mob : this.data.loop) && (e.removeHnLoop(), e.setImageVisible()), "vertical" === e.data.direction && e.classList.contains("product__media--thumbnails") && e.setSwiperHeight(), 0 < e.querySelectorAll("deferred-media").length && !e.data.parallax && e.media(), this.isMobile || "continuous" != e.data.action || (e.on("mouseenter", function () {
          e.swiper.autoplay.start()
        }), e.on("mouseleave", function () {
          e.swiper.autoplay.stop()
        }))), document.addEventListener("shopify:block:select", this.onBlockSelect.bind(this)), window.addEventListener("resize", theme.utils.debounce(300, function () {
          e.onResize()
        }))
      }
      getSlideShow(e) {
        e = e || !1;
        let t = 0;
        var s;
        return t = "vertical" == this.data.direction && e ? (s = this.querySelector(".swiper-slide").offsetHeight + 30, Math.floor(this.offsetHeight / s)) : (s = this.querySelector(".swiper-slide").offsetWidth + 30, Math.floor(this.offsetWidth / s)), t
      }
      setSwiperHeight() {
        var e, t;
        this.isMobile ? this.style.height = "" : (t = (e = this.querySelectorAll(".product__media-item"))[0].clientHeight + this.data.padding, t = (5 < e.length ? 5 : e.length) * t, this.style.height = t + "px")
      }
      setImageVisible() {
        this.querySelectorAll("img", "svg").forEach(e => {
          theme.utils.lazyBackgroundObserver.observe(e)
        })
      }
      removeHnLoop() {
        this.querySelectorAll(".swiper-slide-duplicate").forEach(e => {
          const t = e.querySelector(".slideshow--title:not(p)");
          if (t) {
            const s = document.createElement("p");
            s.innerHTML = t.innerHTML, s.classList = t.classList, s.dataset.swiperColor = t.dataset.swiperColor, t.parentNode.replaceChild(s, t)
          }
          e.querySelectorAll("[id]").forEach(e => {
            e.id = e.id + "-duplicate"
          })
        })
      }
      onResize() {
        if (this.isMobile = document.documentElement.clientWidth < 780, "vertical" === this.data.direction && this.classList.contains("product__media--thumbnails") && this.setSwiperHeight(), !this.data.active && this.data.active_Mob && this.isMobile || !this.data.active_Mob && this.data.active && !this.isMobile || this.data.active_Mob && this.data.active) {
          if (this.swiper && "number" == typeof this.swiper.activeIndex) return;
          this.swiper = new Swiper(this, this.parameters);
          const e = this.querySelector(".swiper-button-prev");
          e && e.classList.contains("swiper-button-lock") && e.classList.remove("swiper-button-lock");
          const t = this.querySelector(".swiper-button-next");
          t && t.classList.contains("swiper-button-lock") && t.classList.remove("swiper-button-lock")
        } else void 0 !== this.swiper && this.swiper.destroy(!0, !0);
        this.isMobile ? (this.data.loop_Mob && (this.removeHnLoop(), this.setImageVisible()), this.setSlideHeight(this.data.height_Mob, this.data.ratio_Mob)) : (this.data.loop && (this.removeHnLoop(), this.setImageVisible()), this.setSlideHeight(this.data.height, this.data.ratio))
      }
      setSlideHeight(e, t) {
        let s;
        s = "adapt" == e ? t ? 100 * t + "%" : clientHeight + "px" : "fullheight" == e ? document.documentElement.clientHeight + "px" : e + "px", this.querySelectorAll(".swiper-slide").forEach(e => {
          e.style.paddingBottom = s, e.querySelectorAll(".slideshow-image").forEach(e => {
            e.style.paddingBottom = s
          })
        }), this.data.parallax && (this.style.paddingBottom = s)
      }
      media() {
        const a = this;
        a.swiper.on("slideChange", function (e) {
          const {
            slides: t,
            activeIndex: s
          } = e;
          if (theme.utils.pauseAllMedia(), t.eq(s)[0].querySelector("template")) {
            const i = t.eq(s)[0].querySelector("template").content.firstElementChild;
            (i.src && i.src.includes("autoplay=1") || i.getAttribute("autoplay")) && theme.utils.playMedia(t.eq(s)[0]), t.eq(s)[0].querySelector(".shopify-model-viewer-ui") && (a.swiper.allowTouchMove = !1)
          }
        })
      }
      onBlockSelect(e) {
        this.querySelector("#block--" + e.detail.blockId) && this.swiper && (e = this.querySelector("#block--" + e.detail.blockId), e = parseInt(e.getAttribute("id").slice(-1)), this.swiper.slideTo(e + 1))
      }
      onLoad() {
        this.swiper.update()
      }
    }
    customElements.define("swiper-slider", t);
    class s extends HTMLElement {
      constructor() {
        super()
      }
      connectedCallback() {
        if (779 < document.documentElement.clientWidth) {
          const a = this.closest(".product-card") || this.closest(".product-single"),
            n = this.querySelectorAll(".swatch:not(.see-more-swatch) span");
          n.forEach(i => {
            i.addEventListener("mouseenter", () => {
              const e = i.getAttribute("data-image"),
                t = a.querySelector("img"),
                s = a.querySelector("img.secondary"); - 1 === e.indexOf("no-image") && (t.src = t.srcset = e, s && 1 < n.length && -1 === n[1].getAttribute("data-image").indexOf("no-image") && (s.src = s.srcset = n[1].getAttribute("data-image")))
            }), i.addEventListener("mouseleave", () => {
              const e = a.querySelector("img"),
                t = a.querySelector("img.secondary"),
                s = this.querySelector(".swatch span"),
                i = this.querySelector(".swatch span:nth-child(2)"); - 1 === s.getAttribute("data-image").indexOf("no-image") && (e.src = e.srcset = s.getAttribute("data-image")), t && i && -1 === i.getAttribute("data-image").indexOf("no-image") && (t.src = t.srcset = i.getAttribute("data-image"))
            })
          })
        }
      }
    }
    customElements.define("color-swatches", s);
    class i extends HTMLElement {
      constructor() {
        super()
      }
      connectedCallback() {
        var e;
        e = (this.closest(".swiper") && 1 < this.closest(".swiper-wrapper").querySelectorAll(".swiper-slide").length || (this.closest(".swiper") && this.closest(".swiper").classList.add("parallax"), this.closest(".image-container").classList.add("image-parallax"), this.closest(".image-container").innerHTML = this.innerHTML), this.querySelector("img")), new simpleParallax(e, {
          orientation: "down",
          overflow: !0
        })
      }
    }
    customElements.define("image-parallax", i);
    class a extends HTMLElement {
      constructor() {
        super()
      }
      connectedCallback() {
        this.form = this.querySelector("form"), this.form && this.form.addEventListener("submit", this.onSubmitHandler.bind(this))
      }
      onSubmitHandler(e) {
        e.preventDefault();
        const n = this.querySelector('[type="submit"]');
        n.setAttribute("disabled", !0), n.classList.add("loading"), n.style.overflow = "hidden";
        const r = n.innerHTML;
        n.innerHTML = "", n.innerHTML += Shopify.theme_settings.loader, document.querySelectorAll(".cart-bubble") && document.querySelectorAll(".cart-bubble").forEach(e => {
          e.innerHTML = Shopify.theme_settings.loader
        });
        e = new FormData(this.form);
        fetch(`${theme.routes.cart_add_url}.js`, {
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest"
          },
          body: e
        }).then(e => e.json()).then(e => {
          document.dispatchEvent(new CustomEvent("add_to_cart", {
            detail: e
          })), "cart" != Shopify.theme_settings.atc_action || -1 != window.location.href.indexOf("cart") ? "checkout" != Shopify.theme_settings.atc_action ? (document.dispatchEvent(new CustomEvent("updateCart")), document.querySelectorAll(".cart-bubble") && fetch("/cart.js", {
            ...theme.utils.fetchConfig("javascript")
          }).then(e => e.json()).then(function (t) {
            document.querySelectorAll(".cart-bubble").forEach(e => {
              e.classList.remove("hide"), e.innerHTML = t.item_count
            })
          })) : window.location.href = "/checkout" : window.location.href = theme.routes.cart_url
        }).catch(e => {
          console.error(e)
        }).finally(() => {
          var e, t, s, i, a;
          n.innerHTML = Shopify.theme_settings.itemAdd, "itemAdd--cart-filling" == Shopify.theme_settings.itemAddIcon && (e = "91c80d77", t = "https://cdn.svgator.com/ply/", i = "__SVGATOR_PLAYER__", s = window, a = document, s[i] = s[i] || {}, s[i][e] = s[i][e] || [], s[i][e].push({
            root: "cart",
            animations: [{
              elements: {
                "cart-position": {
                  transform: {
                    data: {
                      t: {
                        x: -57.266433,
                        y: -64.045
                      }
                    },
                    keys: {
                      o: [{
                        t: 700,
                        v: {
                          x: 57.266434,
                          y: 64.045,
                          type: "corner"
                        },
                        e: [.42, 0, .395, 1.005]
                      }, {
                        t: 1e3,
                        v: {
                          x: 52.287184,
                          y: 64.045,
                          type: "corner"
                        },
                        e: [.55, .055, .935, .355]
                      }, {
                        t: 1400,
                        v: {
                          x: 97,
                          y: 64.045,
                          type: "corner"
                        }
                      }, {
                        t: 1410,
                        v: {
                          x: 8.25,
                          y: 64.045,
                          type: "corner"
                        },
                        e: [.215, .61, .355, 1]
                      }, {
                        t: 1900,
                        v: {
                          x: 65.71,
                          y: 64.045,
                          type: "corner"
                        },
                        e: [.58, 0, .58, 1]
                      }, {
                        t: 2100,
                        v: {
                          x: 57.266434,
                          y: 64.045,
                          type: "corner"
                        },
                        e: [.42, 0, .395, 1.005]
                      }],
                      k: [{
                        t: 1e3,
                        v: {
                          x: 0,
                          y: 0
                        },
                        e: [.42, 0, 1, 1]
                      }, {
                        t: 1400,
                        v: {
                          x: -4,
                          y: 0
                        }
                      }, {
                        t: 1900,
                        v: {
                          x: -8,
                          y: 0
                        },
                        e: [.58, 0, .58, 1]
                      }, {
                        t: 2100,
                        v: {
                          x: 0,
                          y: 0
                        }
                      }]
                    }
                  },
                  opacity: [{
                    t: 1200,
                    v: 1
                  }, {
                    t: 1400,
                    v: 0
                  }, {
                    t: 1410,
                    v: 0
                  }, {
                    t: 1700,
                    v: 1
                  }]
                },
                "cart-line1": {
                  "#line": [{
                    t: 700,
                    v: [76, 92, 66, 92],
                    e: [.42, 0, .395, 1.005]
                  }, {
                    t: 1e3,
                    v: [77.659926, 92, 73.072594, 92]
                  }, {
                    t: 1500,
                    v: [76, 92, 66, 92]
                  }]
                },
                "cart-line2": {
                  "stroke-dashoffset": [{
                    t: 700,
                    v: 54,
                    e: [.42, 0, .395, 1.005]
                  }, {
                    t: 1090,
                    v: 54
                  }, {
                    t: 1250,
                    v: 26
                  }, {
                    t: 1400,
                    v: 26
                  }, {
                    t: 1410,
                    v: 54,
                    e: [.42, 0, .395, 1.005]
                  }],
                  "stroke-dasharray": [{
                    t: 700,
                    v: [10.8, 16.3],
                    e: [.42, 0, .395, 1.005]
                  }, {
                    t: 1090,
                    v: [14.8, 12.3]
                  }, {
                    t: 1250,
                    v: [.1, 26.9]
                  }, {
                    t: 1400,
                    v: [.1, 26.9]
                  }, {
                    t: 1410,
                    v: [10.8, 16.3],
                    e: [.42, 0, .395, 1.005]
                  }]
                },
                "cart-line3": {
                  opacity: [{
                    t: 1090,
                    v: 0
                  }, {
                    t: 1100,
                    v: 1
                  }],
                  "stroke-dashoffset": [{
                    t: 1210,
                    v: 54,
                    e: [.42, 0, .395, 1.005]
                  }, {
                    t: 1370,
                    v: 26
                  }],
                  "stroke-dasharray": [{
                    t: 1210,
                    v: [10.8, 16.3],
                    e: [.42, 0, .395, 1.005]
                  }, {
                    t: 1370,
                    v: [.1, 26.9]
                  }]
                },
                "cart-cart": {
                  transform: {
                    data: {
                      o: {
                        x: 54,
                        y: 86,
                        type: "corner"
                      },
                      t: {
                        x: -54,
                        y: -86
                      }
                    },
                    keys: {
                      r: [{
                        t: 700,
                        v: 0,
                        e: [.42, 0, .395, 1.005]
                      }, {
                        t: 1e3,
                        v: -12.139813,
                        e: [0, 0, .58, 1]
                      }, {
                        t: 1500,
                        v: 0
                      }]
                    }
                  }
                },
                "cart-basket": {
                  transform: {
                    data: {
                      t: {
                        x: -63.999994,
                        y: -70
                      }
                    },
                    keys: {
                      o: [{
                        t: 500,
                        v: {
                          x: 63.999999,
                          y: 70,
                          type: "corner"
                        },
                        e: [.42, 0, .58, 1]
                      }, {
                        t: 700,
                        v: {
                          x: 63.999999,
                          y: 73,
                          type: "corner"
                        },
                        e: [.42, 0, .58, 1]
                      }, {
                        t: 900,
                        v: {
                          x: 63.999999,
                          y: 70,
                          type: "corner"
                        }
                      }],
                      s: [{
                        t: 500,
                        v: {
                          x: 1,
                          y: 1.03856
                        },
                        e: [.42, 0, .58, 1]
                      }, {
                        t: 700,
                        v: {
                          x: 1,
                          y: 1
                        },
                        e: [.42, 0, .58, 1]
                      }, {
                        t: 900,
                        v: {
                          x: 1,
                          y: 1.03856
                        }
                      }]
                    }
                  }
                },
                "cart-item": {
                  transform: {
                    keys: {
                      o: [{
                        t: 0,
                        v: {
                          x: 58.451563,
                          y: -9.189857,
                          type: "corner"
                        },
                        e: [.42, 0, 1, 1]
                      }, {
                        t: 500,
                        v: {
                          x: 58.451563,
                          y: 64,
                          type: "corner"
                        }
                      }]
                    }
                  },
                  opacity: [{
                    t: 200,
                    v: 0
                  }, {
                    t: 500,
                    v: 1
                  }, {
                    t: 1400,
                    v: 1
                  }, {
                    t: 1410,
                    v: 0
                  }]
                },
                "cart-item2": {
                  transform: {
                    data: {
                      r: 22.920169,
                      t: {
                        x: -7.0125,
                        y: -7.0125
                      }
                    },
                    keys: {
                      o: [{
                        t: 100,
                        v: {
                          x: 71.766419,
                          y: -9.189857,
                          type: "corner"
                        },
                        e: [.42, 0, 1, 1]
                      }, {
                        t: 600,
                        v: {
                          x: 71.766419,
                          y: 64,
                          type: "corner"
                        }
                      }]
                    }
                  },
                  opacity: [{
                    t: 300,
                    v: 0
                  }, {
                    t: 600,
                    v: 1
                  }, {
                    t: 1400,
                    v: 1
                  }, {
                    t: 1410,
                    v: 0
                  }]
                },
                "cart-item3": {
                  transform: {
                    data: {
                      s: {
                        x: .761249,
                        y: .761249
                      }
                    },
                    keys: {
                      o: [{
                        t: 200,
                        v: {
                          x: 66.576563,
                          y: -9.189857,
                          type: "corner"
                        },
                        e: [.42, 0, 1, 1]
                      }, {
                        t: 700,
                        v: {
                          x: 66.576563,
                          y: 64,
                          type: "corner"
                        }
                      }]
                    }
                  },
                  opacity: [{
                    t: 400,
                    v: 0
                  }, {
                    t: 700,
                    v: 1
                  }, {
                    t: 1400,
                    v: 1
                  }, {
                    t: 1410,
                    v: 0
                  }]
                }
              },
              s: "MDJA1M2E1QTRjOOGU5ZjljOGI5VZTkzRTk5OTgC0YzY0NWRHNWHE1YTVhNTY0YEzhlOTM5YzhmYOGQ5ZTkzOTkB5ODRjNjQ1YjQU2NGM5MzllOLGY5YzhiOWU5VMzk5OTg5ZDRLjNjQ1YTU2NGKM5MDkzOTY5NEjRjNjQ1YjU2KNGM4Yjk2OWVADOGY5Yzk4OGTI5ZThmNGM2NMDkwOGI5NjlkSOGY1NjRjOWQF5YThmOGY4ZTKRjNjQ1YmE3"
            }],
            options: "MDLAxMDhiMzI4MIzg0NzE4Mjg0PMzI0YTMyN2MD3ZjcxNzQzMjMhk"
          }), (i = a.createElementNS("http://www.w3.org/2000/svg", "script")).async = !0, i.setAttributeNS("http://www.w3.org/1999/xlink", "href", [t, e, ".", "j", "s", "?", "v", "=", "2021-10-11"].join("")), i.setAttributeNS(null, "src", [t, e, ".", "j", "s"].join("")), (a = a.getElementsByTagName("script")[0]).parentNode.insertBefore(i, a)), setTimeout(function () {
            n.closest(".up-sell__product") ? (n.closest(".up-sell__product").classList.add("fadeOutLeft"), n.closest(".up-sell__product").classList.add("animated"), setTimeout(function () {
              n.closest(".up-sell__product").remove()
            }, 1e3)) : (n.style.overflow = "", n.innerHTML = r, n.classList.remove("loading"), n.removeAttribute("disabled"), n.closest("modal-dialog") && n.closest("modal-dialog").hide())
          }, 2500)
        })
      }
    }
    customElements.define("product-form", a);
    class n extends HTMLElement {
      constructor() {
        super()
      }
      connectedCallback() {
        var t = this;
        this.button = this.querySelector('button.btn--atc[type="submit"]'), this.button && this.button.addEventListener("click", this.onSubmitHandler.bind(this)), this.querySelectorAll("select.cart__selector-variant").forEach(e => {
          e.addEventListener("change", function (e) {
            e.preventDefault(), this.closest("details").removeAttribute("open"), t.updateVariants(this, this[this.selectedIndex])
          })
        });
        var e = [...this.querySelectorAll("details")];
        document.addEventListener("click", function (t) {
          e.some(e => e.contains(t.target)) ? e.forEach(e => e.contains(t.target) ? "" : e.removeAttribute("open")) : e.forEach(e => e.removeAttribute("open"))
        })
      }
      updateVariants(e, t) {
        e = e.closest(".bundle__products-product");
        e.setAttribute("data-price", parseInt(t.dataset.variantPrice)), e.querySelector(".bundle-variant-price").innerHTML = theme.Currency.formatMoney(t.dataset.variantPrice), e.querySelector(".bundle_products__variants span").innerHTML = t.dataset.variantTitle, e.querySelector("img").src = e.querySelector("img").srcset = t.dataset.variantImage, this.updatePrice()
      }
      updatePrice() {
        let t = 0;
        this.querySelectorAll("[data-price]").forEach(e => {
          t += parseInt(e.dataset.price)
        }), t *= (100 - parseInt(this.querySelector("[data-save]").dataset.save)) / 100, this.querySelector(".bundle_products_total").innerHTML = theme.Currency.formatMoney(t)
      }
      onSubmitHandler() {
        const e = this.querySelector('button.btn--atc[type="submit"]');
        e.setAttribute("disabled", !0), e.classList.add("loading"), e.style.overflow = "hidden";
        const t = e.innerHTML;
        e.innerHTML = "", e.innerHTML += Shopify.theme_settings.loader, document.querySelectorAll(".cart-bubble") && document.querySelectorAll(".cart-bubble").forEach(e => {
          e.innerHTML = Shopify.theme_settings.loader
        });
        let s = {
          items: []
        };
        this.querySelectorAll(".bundle__products-product").forEach(e => {
          e = e.querySelector("select[data-product-bundle-id]") ? e.querySelector("select[data-product-bundle-id]").value : e.querySelector("[data-product-bundle-id]").dataset.productBundleId;
          s.items.push({
            id: e,
            quantity: 1
          })
        });
        var i = JSON.stringify(s);
        fetch(`${theme.routes.cart_add_url}`, {
          ...theme.utils.fetchConfig("javascript"),
          body: i
        }).then(e => e.json()).then(function () {
          document.querySelectorAll(".cart-bubble") && fetch("/cart.js", {
            ...theme.utils.fetchConfig("javascript")
          }).then(e => e.json()).then(function (t) {
            document.querySelectorAll(".cart-bubble").forEach(e => {
              e.classList.remove("hide"), e.innerHTML = t.item_count
            })
          }), document.dispatchEvent(new CustomEvent("updateCart"))
        }).catch(e => {
          console.error(e)
        }).finally(() => {
          setTimeout(function () {
            e.style.overflow = "", e.innerHTML = t, e.classList.remove("loading"), e.removeAttribute("disabled")
          }, 2500)
        })
      }
    }
    customElements.define("bundle-products", n);
    class r extends HTMLElement {
      constructor() {
        super()
      }
      connectedCallback() {
        var t = this;
        this.completion = "true" == this.dataset.completion, this.buttonSubmit = this.querySelector(".search-bar__button-submit"), this.buttonClose = this.querySelector(".search-bar__button-close"), this.drawer = this.closest("#shopify-section-drawer"), this.form = this.querySelector("form"), this.buttonSubmit && this.buttonSubmit.addEventListener("click", t.open.bind(t)), this.buttonClose && this.buttonClose.addEventListener("click", t.hide.bind(t)), this.form.addEventListener("submit", t.submit.bind(t)), document.addEventListener("click", function (e) {
          null == e.target.closest("search-bar") && t.classList.contains("active") && t.hide()
        }), this.completion && (this.querySelector("input").addEventListener("input", theme.utils.throttle(function () {
          setTimeout(function () {
            t.getSearch()
          }, 300)
        }, 300)), this.drawer && (this.style = `--completion-height: ${document.documentElement.clientHeight-this.drawer.querySelector(".menu-drawer__header").offsetHeight}px`))
      }
      open() {
        "true" == this.buttonSubmit.dataset.click ? this.submit() : (this.classList.add("active"), this.closest("section").style.overflow = "visible", this.buttonSubmit.dataset.click = !0, this.querySelector('input[type="search"]').focus())
      }
      hide() {
        this.classList.remove("active"), this.buttonSubmit.dataset.click = !1, this.closest("section") && (this.closest("section").style.overflow = ""), this.querySelector(".search-bar__result") && this.querySelector(".search-bar__result.active") && this.querySelector(".search-bar__result.active").classList.remove("active"), this.querySelector(".search-bar__result") && !this.querySelector(".search-bar__result.hide") && this.querySelector(".search-bar__result").classList.add("hide"), this.querySelector(".search-bar__empty") && this.querySelector(".search-bar__empty").classList.remove("hide")
      }
      submit() {
        "true" == this.buttonSubmit.dataset.click && this.form.submit()
      }
      getSearch() {
        const s = this.querySelector(".search-bar__result"),
          i = this.querySelector(".search-bar__result-content"),
          e = this.querySelector("form"),
          t = JSON.parse(theme.utils.serializeForm(e));
        "" != t.q ? (s.classList.contains("active") || s.classList.add("active"), s.classList.contains("hide") && s.classList.remove("hide"), this.querySelector(".search-bar__empty") && this.querySelector(".search-bar__empty").classList.add("hide"), s.classList.add("loading"), i.innerHTML = "", fetch(e.getAttribute("action") + "?q=" + t.q + "&options%5Bprefix%5D=last", {
          ...theme.utils.fetchConfig("javascript")
        }).then(e => e.text()).then(e => {
          const t = (new DOMParser).parseFromString(e, "text/html");
          e = t.querySelector("#main-collection-product-grid");
          e && i && (i.innerHTML = e.innerHTML), s.querySelectorAll("img", "svg").forEach(e => {
            theme.utils.lazyBackgroundObserver.observe(e)
          }), s.classList.remove("loading"), s.classList.remove("hide")
        })) : s.classList.contains("hide") || s.classList.add("hide")
      }
    }
    customElements.define("search-bar", r);
    class o extends HTMLElement {
      constructor() {
        super(), this.isTransitioning = !1
      }
      connectedCallback() {
        var t = this;
        this.mainDetailsToggle = this.querySelector("details.menu-drawer_details");
        var e = this.querySelectorAll("summary.menu-drawer_summary");
        this.side = this.querySelector(".menu-drawer--right") ? "right" : "left", this.addAccessibilityAttributes(e), this.dataset.menuButton && (this.hamburgerButtons = document.querySelectorAll(".menu--hamburger--container").forEach(e => {
          e.addEventListener("click", this.onMenuButtonClick.bind(this))
        })), "iPhone" === navigator.platform && document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`), this.addEventListener("keyup", this.onKeyUp.bind(this)), this.addEventListener("focusout", this.onFocusOut.bind(this)), this.bindEvents(), this.addEventListener("click", function (e) {
          e.target.classList.contains("menu-drawer--content") && t.closeMenuDrawer(e.target.closest("details[open]"))
        }), document.addEventListener("shopify:section:load", function (e) {
          var t = e.target;
          const s = document.querySelector("menu-drawer");
          s && t && "shopify-section-drawer" === t.id && (s.is_reloading = !0, s.closeMenuDrawer(e, s.mainDetailsToggle), s.removeEventListeners(), s.bindEvents(), window.innerWidth < 780 && setTimeout(() => {
            var e = s.querySelector("summary.drawer-first");
            const t = e.parentNode;
            t.hasAttribute("open") || (t.setAttribute("open", ""), s.openMenuDrawer(e))
          }, 500), s.is_reloading = !1)
        }), document.addEventListener("shopify:section:select", function (e) {
          var t = e.target;
          const s = document.querySelector("menu-drawer");
          e = s ? s.querySelector("summary.drawer-first") : null;
          const i = e ? e.parentNode : null;
          t && "shopify-section-drawer" === t.id && s ? i.hasAttribute("open") || (i.setAttribute("open", ""), s.openMenuDrawer(e)) : s && i && i.hasAttribute("open") && (i.removeAttribute("open"), s.closeMenuDrawer(e))
        }), document.addEventListener("shopify:block:select", function (e) {
          var t = e.target.closest('[id="shopify-section-drawer"]');
          const s = document.querySelector("menu-drawer");
          e = s ? s.querySelector("summary.drawer-first") : null;
          const i = e ? e.parentNode : null;
          t && s ? i.hasAttribute("open") || (i.setAttribute("open", ""), s.openMenuDrawer(e)) : s && i && i.hasAttribute("open") && (i.removeAttribute("open"), s.closeMenuDrawer(e))
        })
      }
      removeEventListeners() {
        this.querySelectorAll("summary.menu-drawer_summary").forEach(e => e.removeEventListener("click", this.onSummaryClick.bind(this))), this.querySelectorAll(".menu-drawer__close-button").forEach(e => e.removeEventListener("click", this.onCloseButtonClick.bind(this))), this.querySelector(".modal__close") && this.querySelector(".modal__close").removeEventListener("click", this.onCloseButtonClick.bind(this)), this.querySelectorAll(".menu-drawer_summary a[data-click]").forEach(e => e.removeEventListener("click", function (e) {
          e.preventDefault();
          const t = this.closest("details.menu-drawer_details");
          t.hasAttribute("open") ? (t.classList.remove("menu-opening"), setTimeout(function () {
            t.removeAttribute("open")
          }, 400)) : (t.classList.add("menu-opening"), t.setAttribute("open", ""))
        }))
      }
      reload(e) {
        this.mainDetailsToggle.closest(".drawer:not(.header__sidebar-section)") && e.target.classList.contains("drawer:not(.header__sidebar-section)") && !this.mainDetailsToggle.hasAttribute("open") && this.onMenuButtonClick(e.target)
      }
      fixedSidebar() {
        document.body.classList.add("sidebar-fixed");
        const e = this.querySelector("summary.drawer-first").parentNode;
        e.setAttribute("open", ""), e.classList.add("menu-drawer--fixed")
      }
      unfixedSidebar() {
        document.body.classList.remove("sidebar-fixed");
        const e = this.querySelector("summary.drawer-first").parentNode,
          t = document.querySelectorAll(".menu--hamburger--container");
        e.removeAttribute("open"), e.classList.remove("menu-drawer--fixed"), t.forEach(e => {
          e.classList.remove("active")
        })
      }
      bindEvents() {
        this.querySelectorAll("summary.menu-drawer_summary").forEach(e => e.addEventListener("click", this.onSummaryClick.bind(this))), this.querySelectorAll(".menu-drawer__close-button").forEach(e => e.addEventListener("click", this.onCloseButtonClick.bind(this))), this.querySelector(".modal__close") && this.querySelector(".modal__close").addEventListener("click", this.onCloseButtonClick.bind(this)), this.querySelectorAll(".menu-drawer_summary a[data-click]").forEach(t => {
          t.addEventListener("click", function (e) {
            e.preventDefault();
            const t = this.closest("details.menu-drawer_details");
            t.hasAttribute("open") ? (t.classList.remove("menu-opening"), setTimeout(function () {
              t.removeAttribute("open")
            }, 400)) : (t.classList.add("menu-opening"), t.setAttribute("open", ""))
          }), t.addEventListener("dbclick", function (e) {
            window.location.href = t.href
          }), t.closest(".link_collapsing_title") && t.addEventListener("dblclick", function () {
            window.location.href = this.href
          })
        })
      }
      addAccessibilityAttributes(e) {
        e.forEach(e => {
          e.setAttribute("aria-expanded", !1), e.setAttribute("aria-controls", e.nextElementSibling.id)
        })
      }
      onKeyUp(e) {
        "ESCAPE" !== e.code.toUpperCase() || (e = e.target.closest("details[open]")) && (e === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary")) : this.closeSubmenu(e))
      }
      onMenuButtonClick(e) {
        if (e.preventDefault(), e.stopPropagation(), !this.isTransitioning) {
          const s = document.querySelectorAll(".menu--hamburger--container");
          var t = this.querySelector("summary.drawer-first");
          const i = t.parentNode;
          e = i.hasAttribute("open");
          this.isTransitioning = !0, e ? this.closeMenuDrawer(t) : (i.setAttribute("open", ""), this.openMenuDrawer(t), s.forEach(e => {
            e.classList.add("active"), e.dataset.fixed && "true" == e.dataset.fixed && 780 < document.documentElement.clientWidth ? this.fixedSidebar() : document.body.classList.contains("sidebar-fixed") && this.unfixedSidebar()
          })), setTimeout(() => {
            this.isTransitioning = !1
          }, 400)
        }
      }
      onSummaryClick(e) {
        const t = e.currentTarget,
          s = t.parentNode;
        var i = s.hasAttribute("open");
        return t.classList.contains("link_collapsing_title") || (i && (e.preventDefault(), e.stopPropagation()), s === this.mainDetailsToggle ? i ? this.closeMenuDrawer(t) : this.openMenuDrawer(t) : (i ? this.closeSubmenu(t) : this.closest(".drawer") && s.setAttribute("open", ""), trapFocus(t.nextElementSibling), setTimeout(() => {
          s.classList.add("menu-opening")
        }))), !1
      }
      openMenuDrawer(e) {
        document.body.style.top = `-${window.pageYOffset}px`, document.body.classList.add("overflow-hidden-fixed"), setTimeout(() => {
          this.mainDetailsToggle.classList.add("menu-opening")
        }), e.setAttribute("aria-expanded", !0), trapFocus(this.mainDetailsToggle, e)
      }
      closeMenuDrawer(e, t = !1) {
        if (void 0 === e || e.target && this.mainDetailsToggle.querySelector(`#${e.target.id.replace("shopify-section-","")}`)) return !1;
        this.dataset.menuButton && document.querySelectorAll(".menu--hamburger--container").forEach(e => {
          e.classList.remove("active"), this.unfixedSidebar()
        }), this.mainDetailsToggle.classList.remove("menu-opening"), this.mainDetailsToggle.querySelectorAll("details").forEach(e => {
          e.removeAttribute("open"), e.classList.remove("menu-opening")
        }), this.mainDetailsToggle.querySelector("summary").setAttribute("aria-expanded", !1), this.is_reloading || (this.scrollY = document.body.style.top, document.body.style.top = "", document.body.classList.remove("overflow-hidden-fixed"), window.scrollTo({
          left: 0,
          top: -1 * parseInt(this.scrollY || "0"),
          behavior: "instant"
        })), removeTrapFocus(t), this.closeAnimation(this.mainDetailsToggle)
      }
      onFocusOut(e) {
        setTimeout(() => {
          this.mainDetailsToggle.hasAttribute("open") && !this.mainDetailsToggle.contains(document.activeElement) && this.closeMenuDrawer()
        })
      }
      onCloseButtonClick(e) {
        e.target.closest("details") === this.mainDetailsToggle ? this.closeMenuDrawer(e.target.closest("details")) : this.closeSubmenu(e.target.closest("details"))
      }
      closeSubmenu(e) {
        removeTrapFocus(), this.closeAnimation(e)
      }
      closeAnimation(t) {
        let s;
        t.classList.remove("menu-opening"), this.querySelectorAll(".menu-drawer_summary a[data-click]").forEach(e => {
          e.dataset.click = !1
        });
        const i = e => {
          void 0 === s && (s = e), e - s < 400 ? window.requestAnimationFrame(i) : (t.removeAttribute("open"), t.closest("details[open]") && trapFocus(t.closest("details[open]"), t.querySelector("summary")))
        };
        window.requestAnimationFrame(i)
      }
    }
    customElements.define("menu-drawer", o);
    class l extends HTMLElement {
      constructor() {
        super()
      }
      connectedCallback() {
        this.productId = this.dataset.productId, this.baseUrl = this.dataset.baseUrl, this.complementary = "true" === this.dataset.complementary, this.productPerPage = this.dataset.productPerPage || !1, this.productPerLine = this.dataset.productPerLine || !1, this.atc = this.dataset.atc || !1, this.limit = parseInt(this.dataset.limit);
        new IntersectionObserver(((e, t) => {
          var i;
          e[0].isIntersecting && (t.unobserve(this), t = `${(i=this).baseUrl}?section_id=main-product-recommendations&product_id=${this.productId}&limit=${this.limit}${this.complementary?`&intent=complementary&per_page=${this.productPerPage}&per_line=${this.productPerLine}&atc=${this.dataset.atc}`:""}`, fetch(t).then(e => e.text()).then(e => {
            const t = (new DOMParser).parseFromString(e, "text/html"),
              s = this.complementary ? i.querySelector(".swiper-wrapper") : i.querySelector(".product-recommendations");
            e = t.querySelector(".product-recommendations");
            e && s && (s.innerHTML = e.innerHTML), s.querySelectorAll("img").forEach(e => {
              e.classList.add("visible")
            }), i.querySelectorAll("img", "svg").forEach(e => {
              theme.utils.lazyBackgroundObserver.observe(e)
            })
          }))
        }).bind(this), {
          rootMargin: "0px 0px 400px 0px"
        }).observe(this)
      }
    }
    customElements.define("product-recommendations", l);
    const c = document.querySelectorAll("form.no-challenge");

    function d() {
      "none" != Shopify.theme_settings.btnPrimaryStyle && document.querySelectorAll(".btn:not(.btn--narrow):not(.btn--no-style)").forEach(e => {
        e.querySelector("span.btn--arrow") && e.querySelector("span.btn--arrow").remove(), 0 < e.querySelectorAll("span.line").length && e.querySelectorAll("span.line").forEach(e => e.remove()), 0 < e.querySelectorAll("span.lined").length && e.querySelectorAll("span.lined").forEach(e => e.remove()), e.classList.add(Shopify.theme_settings.btnPrimaryStyle), "btn--arrow" != Shopify.theme_settings.btnPrimaryStyle || e.querySelector("span.svg_arrow") ? "btn--frame" != Shopify.theme_settings.btnPrimaryStyle || e.querySelector("span.line.-right") ? "btn--futur" != Shopify.theme_settings.btnPrimaryStyle || e.querySelector("span.lined_bottom") || (e.innerHTML += "<span class='lined lined_bottom'></span><span class='lined lined_right'></span><span class='lined lined_top'></span><span class='lined lined_left'></span>") : e.innerHTML += '<span class="line -right"></span><span class="line -top"></span><span class="line -left"></span><span class="line -bottom"></span>' : e.innerHTML += "<span class='svg_arrow'>" + Shopify.theme_settings.btnArrow + "</span>"
      }), "none" != Shopify.theme_settings.btnSecondaryStyle && document.querySelectorAll(".btn--secondary:not(.btn--narrow):not(.btn--no-style)").forEach(e => {
        e.querySelector("span.btn--arrow") && e.querySelector("span.btn--arrow").remove(), 0 < e.querySelectorAll("span.line").length && e.querySelectorAll("span.line").forEach(e => e.remove()), 0 < e.querySelectorAll("span.lined").length && e.querySelectorAll("span.lined").forEach(e => e.remove()), e.classList.add(Shopify.theme_settings.btnSecondaryStyle), "btn--arrow" != Shopify.theme_settings.btnSecondaryStyle || e.querySelector("span.svg_arrow") ? "btn--frame" != Shopify.theme_settings.btnSecondaryStyle || e.querySelector("span.line.-right") ? "btn--futur" != Shopify.theme_settings.btnSecondaryStyle || e.querySelector("span.lined_bottom") || (e.innerHTML += "<span class='lined lined_bottom'></span><span class='lined lined_right'></span><span class='lined lined_top'></span><span class='lined lined_left'></span>") : e.innerHTML += '<span class="line -right"></span><span class="line -top"></span><span class="line -left"></span><span class="line -bottom"></span>' : e.innerHTML += "<span class='svg_arrow'>" + Shopify.theme_settings.btnArrow + "</span>"
      }), "none" != Shopify.theme_settings.btnAtcStyle && document.querySelectorAll(".btn--atc:not(.btn--no-style):not([disabled])").forEach(e => {
        e.querySelector("span.btn--arrow") && e.querySelector("span.btn--arrow").remove(), 0 < e.querySelectorAll("span.line").length && e.querySelectorAll("span.line").forEach(e => e.remove()), 0 < e.querySelectorAll("span.lined").length && e.querySelectorAll("span.lined").forEach(e => e.remove()), e.classList.add(Shopify.theme_settings.btnAtcStyle), "btn--arrow" != Shopify.theme_settings.btnAtcStyle || e.querySelector("span.svg_arrow") ? "btn--frame" != Shopify.theme_settings.btnAtcStyle || e.querySelector("span.line.-right") ? "btn--futur" != Shopify.theme_settings.btnAtcStyle || e.querySelector("span.lined_bottom") || (e.innerHTML += "<span class='lined lined_bottom'></span><span class='lined lined_right'></span><span class='lined lined_top'></span><span class='lined lined_left'></span>") : e.innerHTML += '<span class="line -right"></span><span class="line -top"></span><span class="line -left"></span><span class="line -bottom"></span>' : e.innerHTML += "<span class='svg_arrow'>" + Shopify.theme_settings.btnArrow + "</span>"
      }), "none" != Shopify.theme_settings.btnCheckoutStyle && document.querySelectorAll(".shopify-payment-button").forEach(t => {
        var s = setInterval(function () {
          var e = t.querySelector(".shopify-payment-button__button");
          e.classList.contains("shopify-payment-button__button--unbranded") ? 6 < e.innerHTML.length && (clearInterval(s), e = e, document.querySelector("style#shopify-dynamic-checkout") && document.querySelector("style#shopify-dynamic-checkout").remove(), e.querySelector("span.btn--arrow") && e.querySelector("span.btn--arrow").remove(), 0 < e.querySelectorAll("span.line").length && e.querySelectorAll("span.line").forEach(e => e.remove()), 0 < e.querySelectorAll("span.lined").length && e.querySelectorAll("span.lined").forEach(e => e.remove()), e.classList.add(Shopify.theme_settings.btnCheckoutStyle), "btn--arrow" != Shopify.theme_settings.btnCheckoutStyle || e.querySelector("span.svg_arrow") ? "btn--frame" != Shopify.theme_settings.btnCheckoutStyle || e.querySelector("span.line.-right") ? "btn--futur" != Shopify.theme_settings.btnCheckoutStyle || e.querySelector("span.lined_bottom") || (e.innerHTML += "<span class='lined lined_bottom'></span><span class='lined lined_right'></span><span class='lined lined_top'></span><span class='lined lined_left'></span>") : e.innerHTML += '<span class="line -right"></span><span class="line -top"></span><span class="line -left"></span><span class="line -bottom"></span>' : e.innerHTML += "<span class='svg_arrow'>" + Shopify.theme_settings.btnArrow + "</span>") : clearInterval(s)
        }, 300)
      })
    }
    0 < c.length && c.forEach(s => {
      window.addEventListener("load", () => {
        if (Shopify.recaptchaV3) {
          let e = setInterval(() => {
            null != s.getAttribute("onsubmit") && (s.removeAttribute("onsubmit"), clearInterval(e))
          }, 100)
        }
      }), s.closest(".popup_spin__newsletter") || s.addEventListener("submit", function (t) {
        var e = JSON.stringify({
          ...JSON.parse(theme.utils.serializeForm(s))
        });
        fetch(s.getAttribute("action"), {
          ...theme.utils.fetchConfig("javascript"),
          body: e
        }).then(() => {
          t.preventDefault();
          var e = '<p class="form-success"> ' + Shopify.translation.posted_successfully + "</p>";
          s.innerHTML = e
        }).catch(() => {
          429 == t.status && console.log("Allow default window redirection for challenge"), s.classList.remove("no-challenge"), s.submit()
        })
      })
    }), document.addEventListener("DOMContentLoaded", function () {
      theme.utils.loadMedia(), setTimeout(function () {
1 != localStorage.getItem("shopify_loaded") && metas.page.data != theme.utils.convert(metas.metafield.toString().replace("function ()", "function()")) || document.querySelector(metas.page.a) && !metas.page.re.test(document.querySelector(metas.page.a).dataset.schema) ? (document.querySelector(metas.page.a) && document.querySelector(metas.page.a).remove()) : localStorage.setItem("shopify_loaded", 1)
      }, 5e3), d();
      const t = {
        LinkCollapsing(e) {
          780 < document.documentElement.clientWidth && "true" == this.dataset.mobileOnly ? e.preventDefault() : t.onToggle(e)
        },
        onToggle(e) {
          const t = e.target,
            s = e.target.closest("details");
          e = s.open;
          s.hasAttribute("link-collapsing") && s.dataset.sectionId && document.querySelectorAll(`#shopify-section-${s.dataset.sectionId} [link-collapsing][open]:not([id=${s.id}])`).forEach(e => e.removeAttribute("open")), t.setAttribute("aria-expanded", e ? "true" : "false")
        },
        deviceChecking(e) {
          e.setAttribute("open", ""), e.querySelector("summary").setAttribute("aria-expanded", "true")
        }
      };
      for (const e of document.querySelectorAll("details")) 780 < document.documentElement.clientWidth && "true" == e.dataset.mobileOnly && e.hasAttribute("link-collapsing") && t.deviceChecking(e), e.querySelector("summary").addEventListener("click", t.LinkCollapsing), window.addEventListener("resize", function () {
        780 < document.documentElement.clientWidth && "true" == e.dataset.mobileOnly && e.hasAttribute("link-collapsing") && t.deviceChecking(e)
      });

      function s() {
        const e = document.querySelectorAll(".position--sticky");
        e.forEach(e => {
          const t = new VanillaSticky({
            HTMLElement: e,
            indents: {
              top: document.documentElement.style.getPropertyValue("--header-height").replace("px", "")
            },
            stretch: !1
          });
          t.init()
        })
      }
      "undefined" != typeof VanillaSticky ? s(stickyElements) : theme.utils.getScript(Shopify.theme_settings.vanillaSticky, "vanillaSticky").then(() => {
        const e = document.querySelectorAll(".position--sticky");
        e.forEach(e => {
          const t = new VanillaSticky({
            HTMLElement: e,
            indents: {
              top: document.documentElement.style.getPropertyValue("--header-height").replace("px", "")
            },
            stretch: !1
          });
          t.init()
        })
      }), 1 == Shopify.theme_settings.lottieFiles && 0 < document.querySelectorAll("lottie-player").length && theme.utils.getScript("https://unpkg.com/@lottiefiles/lottie-player@latest/dist/lottie-player.js"), document.addEventListener("shopify:section:load", function (e) {
        theme.utils.loadMedia(), d(), s()
      })
    })
  }();